// extracted by mini-css-extract-plugin
export default {"colorTangelo":"#fc4c02","input":"InputRangeSingle_input__qg8Hq","wrapper":"InputRangeSingle_wrapper__ci3lv"};